import React, { useCallback, useEffect, useState } from "react";
import "./career.css";
import Icons from "../../config/images";
import Header from "../../components/Header/header";
import Footer from "../../components/Footer/footer";
import { toast } from "react-toastify";
import Strings from "../../config/Strings";
import { useDispatch } from "react-redux";
import {
  addHiringAPI,
  getAllPositionAPI,
} from "../../store/action/contactAction";
import { UploadMediaRequestAPI } from "../../store/action/mediaAction";

const CareerPage = () => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    position: "",
    mobile: "",
    email: "",
    resume: null,
  });
  const [hiringPositionData, setHiringPositionData] = useState([]);

  // Function to handle input changes
  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === "file" && files.length > 0) {
      const selectedFile = files[0];

      // Update formData first
      setFormData((prev) => ({
        ...prev,
        [name]: selectedFile,
      }));

      // Dispatch upload API call
      dispatch(
        UploadMediaRequestAPI(
          [selectedFile],
          "resumeDocument",
          false,
          (result) => {
            if (result.status) {
              toast.success(result?.data?.[0]?.message?.message);
              setFormData((prev) => ({
                ...prev,
                resume: selectedFile.name,
                resumeId: result.data[0].file_storage_id, // Save file ID
              }));
            } else {
              toast.error("File upload failed. Please try again.");
            }
          }
        )
      );
    } else {
      // For other input fields
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const requestData = {
      user_name: formData?.name,
      user_mobile_number: formData?.mobile,
      user_email: formData?.email,
      user_apply_for: formData?.position,
      user_resume_id: formData?.resumeId,
    };
    try {
      await dispatch(
        addHiringAPI(requestData, (isSuccess, result) => {
          if (isSuccess.status) {
            setShowModal(false); // Hide modal after submission
            toast.success(result?.message?.message);
          } else {
            toast.error(
              result?.error?.message || Strings.somethingWentWrongError
            );
          }
        })
      );
    } catch (error) {
      console.error("Error updating user status:", error);
      toast.error(Strings.somethingWentWrongError);
    }
  };

  const onClose = useCallback(() => {
    setShowModal(false); // Hide modal after submission
  }, []);

  useEffect(() => {
    dispatch(
      getAllPositionAPI({}, (result) => {
        setHiringPositionData(result);
      })
    );
  }, [dispatch]);

  return (
    <>
      <Header />
      <div className="hiring-container----">
        <h2 className="hiring-title-text-style">We are Hiring</h2>
        <p className="hiring-subtitle">
          Join our team and be part of an exciting journey
        </p>

        {/* Banner Image */}
        <div>
          <img
            src={Icons.career}
            alt="Career Banner"
            className="career-banner-image-style"
          />
        </div>

        {/* Why Join Us Section */}
        <h3 className="section-title">Why Join Us?</h3>
        <p className="section-subtitle">What Sets Us Apart</p>
        <div className="benefits-container">
          <div className="benefit-card">
            <img
              src={Icons.salary}
              className="join-us-image-style"
              alt="icon"
            />
            <p className="benifit-card-text-style">
              Competitive salaries and benefits.
            </p>
          </div>
          <div className="benefit-card">
            <img
              src={Icons.oppournities}
              className="join-us-image-style"
              alt="icon"
            />
            <p className="benifit-card-text-style">
              Opportunities for professional growth and skill development.
            </p>
          </div>
          <div className="benefit-card highlight">
            <img
              src={Icons.enviournment}
              className="join-us-image-style"
              alt="icon"
            />
            <p className="benifit-card-text-style">
              A collaborative and inclusive work environment.
            </p>
          </div>
          <div className="benefit-card">
            <img
              src={Icons.project}
              className="join-us-image-style"
              alt="icon"
            />
            <p className="benifit-card-text-style">
              Exciting projects that challenge and inspire.
            </p>
          </div>
        </div>

        {/* Open Positions Section */}
        <h3 className="section-title">Open Positions</h3>
        <div className="job-listings">
          {/* Graphic Designer Position */}
          <div className="job-card">
            <p className="job-card-bold-text-style">Graphic Designer</p>
            <p className="job-card-parent-text-container">
              <span className="job-card-medium-text-style">
                Experience:
                <span className="job-card-light-text-style">1 Year</span>
              </span>
            </p>

            <p className="job-card-parent-text-container">
              <span className="job-card-medium-text-style">
                Skills:
                <span className="job-card-light-text-style">
                  Proficient in Adobe Creative Suite, creative thinking, and a
                  strong portfolio in branding and digital design.
                </span>
              </span>
            </p>

            <button className="apply-btn" onClick={() => setShowModal(true)}>
              Apply Now
            </button>
          </div>

          {/* Business Development Executive Position */}
          <div className="job-card">
            <p className="job-card-bold-text-style">
              Business Development Executive (BDE)
            </p>

            <p className="job-card-parent-text-container">
              <span className="job-card-medium-text-style">
                Experience:
                <span className="job-card-light-text-style">1 Year</span>
              </span>
            </p>

            <p className="job-card-parent-text-container">
              <span className="job-card-medium-text-style">
                Skills:
                <span className="job-card-light-text-style">
                  Excellent communication, lead generation, and client
                  relationship management.
                </span>
              </span>
            </p>
            <button className="apply-btn" onClick={() => setShowModal(true)}>
              Apply Now
            </button>
          </div>
        </div>

        {/* Modal Form */}
        {showModal && (
          <div className="modal">
            <div className="modal-content">
              <div className="career-page-top-side-container">
                <span className="career-page-text-style">Fill Form</span>
                <img
                  src={Icons.closeIcon}
                  className="career-page-modal-close-icon"
                  alt="closeIcon"
                  onClick={onClose}
                />
              </div>

              <form onSubmit={handleSubmit} className="career-page-form-style">
                <span className="text-input-label-text-style">Name</span>
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="career-page-text-input-div"
                />

                <span className="text-input-label-text-style">Apply For</span>
                <select
                  name="position"
                  value={formData.position}
                  onChange={handleChange}
                  required
                  className="career-page-text-input-div"
                >
                  <option value="" disabled>
                    Select a position
                  </option>
                  {hiringPositionData?.map((e, index) => (
                    <option key={index} value={e?.hiring_position_name}>
                      {e?.hiring_position_name}
                    </option>
                  ))}
                </select>

                <span className="text-input-label-text-style">
                  Mobile Number
                </span>
                <input
                  type="text"
                  name="mobile"
                  placeholder="Mobile Number"
                  value={formData.mobile}
                  onChange={handleChange}
                  required
                  className="career-page-text-input-div"
                />
                <span className="text-input-label-text-style">Email</span>
                <input
                  type="email"
                  name="email"
                  placeholder="Email ID"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="career-page-text-input-div"
                />
                <span className="text-input-label-text-style">
                  Upload Latest Resume
                </span>
                <input
                  type="file"
                  name="resume"
                  onChange={handleChange}
                  required
                  className="career-page-text-input-div"
                />
                <div className="modal-actions">
                  <button type="button" onClick={() => setShowModal(false)}>
                    Cancel
                  </button>
                  <button type="submit">Submit</button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </>
  );
};

export default CareerPage;
